const ACCORDION_CONTENT_PADDING_BOTTOM = 16;

delegateEvent('click', '.accordion__heading', (event) => {
  event.preventDefault();
  const heading = event.target.closest('.accordion__heading');
  const content = heading.nextElementSibling;
  if (heading.classList.contains('is-open')) {
    content.style.maxHeight = '0';
    heading.classList.remove('is-open');
  } else {
    const height = content.scrollHeight + ACCORDION_CONTENT_PADDING_BOTTOM;
    content.style.maxHeight = `${height}px`;
    heading.classList.add('is-open');
  }
});
